module.exports = __webpack_public_path__ + "img/create-employee.79ad342c.png";